import React, { useEffect, useState, useRef } from "react";

//Import components
import Product from "../product/Product";

//Import utils
import { Row, Col, Button } from 'react-bootstrap';

import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltLeft } from '@fortawesome/fontawesome-free-solid'
import { faLongArrowAltRight } from '@fortawesome/fontawesome-free-solid'

import { faChevronRight } from '@fortawesome/fontawesome-free-solid'
import { faChevronLeft } from '@fortawesome/fontawesome-free-solid'

import { faChevronCircleDown } from '@fortawesome/fontawesome-free-solid'


function SmallNextArrow(props) {
    const { onClick } = props;
    return (
        <div onClick={onClick} className="arrow-button-right" role="button"><FontAwesomeIcon size={"lg"} icon={faLongArrowAltRight} /></div>

    );
}
  
function SmallPrevArrow(props) {
    const { onClick } = props;
    return (
        <div onClick={onClick} className="arrow-button-left" role="button"><FontAwesomeIcon size={"lg"} icon={faLongArrowAltLeft} /></div>
    );
}

function SampleNextArrow(props) {
    const { onClick } = props;
    return (
        <div onClick={onClick} className="chevron-button-right" role="button"><FontAwesomeIcon size={"lg"} icon={faChevronRight} /></div>

    );
}
  
function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
        <div onClick={onClick} style={{...style}} className="chevron-button-left" role="button"><FontAwesomeIcon size={"lg"} icon={faChevronLeft} /></div>
    );
}

export default function ResultPage(props) {

    const [product, setProduct] = useState({});
    const [links, setLinks] = useState({});
    const { t } = useTranslation('common');
    const scroll = useRef(null)

    const settings = {
        className: "slider",
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        nextArrow: <SmallNextArrow />,
        prevArrow: <SmallPrevArrow />,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                }
            }
        ]
    };

    const settings_bottom = {
        className: "slider_bottom",
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                }
            }
        ]
    };

    useEffect(() => {
        setProduct(props.product)
        const associativeLinks = Object.assign({}, ...props.links.map(({ean, url}) => ({[ean]: {url}})));
        setLinks(associativeLinks)
    }, [props.product, props.links]);

    function scrollDown() {
        scroll.current.scrollIntoView()  
    }

    const getUrl = (ean) => links[ean] && links[ean].url  ?  links[ean].url : '';
    return(
        <div>
            {Object.keys(product).length ?
                <div className="result-container">
                    {/* <Row className="result-product-row" style={{backgroundImage: "url('teszt.jpeg')", backgroundRepeat: "no-repeat"}}> */}
                        <div className="top-wrapper">                        

                            <Row className="result-product-row" >

                            <Col className="result-product-picture" md={7}>
                                <img alt={product.product_image} src={process.env.PUBLIC_URL + "/images/results/products/" + product.product_image } />
                            </Col>
                            <Col className="result-product-details" md={5}>
                                <h2 className="result-header"><span><img alt="heart" src={process.env.PUBLIC_URL + '/images/icon_heart.svg'} /></span>{t('Your results are in!')}</h2>
                                <p className="result-header-detail">{t('Based on your answers, this shade would look great on you!')}</p>
                                <div className="result-product-details-extended">
                                    <h2 className="result-product-name">{product.product_name}</h2>

                                    <p className="match">{t('Your shade match:')}</p>

                                    <div className="swatch">
                                        <div className="img">
                                            <img alt="swatch" src={process.env.PUBLIC_URL + (product.product_shade ? '/images/swatches/' + product.product_shade + '.png' :'/images/swatch.png')} />
                                        </div>
                                        <div className="name">
                                            <p><span>{product.product_shade_name}</span> <strong>{product.product_shade}</strong></p>
                                            <p className="desc">{t(product.product_shade_description)}</p>
                                        </div>
                                    </div>
                                    <Button href={getUrl(product.product_ean)} target="_blank" className="result-cart-button">{t('Shop Now')}</Button>
                                    <Row className="result-additional-buttons">
                                        <Col md={8} xs={8}>
                                            <Button className="back" onClick={() => {
                                            props.resetQuestionnarie()
                                            props.setDisplayResults(false)}} ><span className="icon"></span>{t('Back to Quiz')}</Button>
                                        </Col>                                
                                    </Row>
                                    <p className="result-details">{t(product.product_description.toString())}</p>
                                    <div className="encourage-to-scroll">
                                        <p>{t("SCROLL DOWN TO DISCOVER HOW TO COMPLETE THE LOOK BASED ON YOUR ANSWERS")}</p>
                                        <FontAwesomeIcon className="down-anim" role="button" onClick={scrollDown} size={"lg"} icon={faChevronCircleDown} />
                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Row className="result-additional-items justify-content-center">
                        {product.lighter_image ?
                        <Col>
                            <Product img={product.lighter_image} title='Shade lighter' price={product.lighter_price} shadeCode={product.lighter_shade} shadeName={product.lighter_shade_name} link={getUrl(product.lighter_ean)} type="texture" />
                        </Col>
                        :null}
                        {product.darker_image ?
                        <Col>
                            <Product img={product.darker_image} title='Shade darker' price={product.darker_price} shadeCode={product.darker_shade} shadeName={product.darker_shade_name} link={getUrl(product.darker_ean)} type="texture"/>
                        </Col>
                        :null}
                    </Row>
                    <Row ref={scroll} className="justify-content-center result-interactive-image-container">
                        <Col className="interactive-image" md={5}>
                            <div className="image">
                                <img alt={"foundation"} src={process.env.PUBLIC_URL + "/images/results/complete/" + props.type + ".jpg"} />
                            </div>
                        </Col>
                        <Col md={7} className="interactive-products">
                            <p>{t('BASED ON YOUR ANSWERS, COMPLETE THE LOOK WITH THESE PERFECT PAIRINGS')}</p>
                            <div className="interactive-products-carosuel">
                                <Slider {...settings}>
                                    {[1, 2, 3, 4].map(key => {
                                        if(product[`complete_product${key}_image`]) {
                                            const ean = product[`complete_product${key}_image`].replace('.jpg','').replace('.png','');;
                                            return(
                                                <Col key={`complete_product${key}_image`}>
                                                    <Product 
                                                        img={product[`complete_product${key}_image`]} 
                                                        title="" 
                                                        price={product[`complete_product${key}_price`]} 
                                                        shadeCode="" 
                                                        shadeName={product[`complete_product${key}_name`]} 
                                                        link={getUrl(ean)} 
                                                        type="product"/>
                                                </Col>
                                            );
                                        }
                                    })}
                                </Slider>
                            </div>
                        </Col>
                    </Row>
                    <p className="use-it-with">{t('Use it with')}</p>
                    <Row className="result-complete-look justify-content-center">
                        <Col className="" sm={12}>
                            <div className="interactive-products-carosuel">
                                {product[`usewith_product1_image`] &&
                                <Slider {...settings_bottom}>
                                    {[1,2,3,4].map(key => {
                                        if(product[`usewith_product${key}_image`]) {
                                            const ean = product[`usewith_product${key}_image`].replace('.jpg','');
                                            return(
                                            <Col key={`usewith_product${key}`}>
                                                <Product img={product[`usewith_product${key}_image`]} title="" price={product[`usewith_product${key}_price`]} shadeCode="" shadeName={product[`usewith_product${key}_name`]} link={getUrl(ean)} type="product"/>
                                            </Col>
                                        );
                                        }
                                    })}
                                </Slider>}

                            </div>
                        </Col>
                    </Row>
                </div>
            : <p className="empty">{t('We did not find any products')}</p>}
        </div>
    )
}
